import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f7f011c0")

_pushScopeId("data-v-f7f011c0")
const _hoisted_1 = { class: "check-time-application-container text-gray-333" }
const _hoisted_2 = { class: "font-bold text-2xl mb-8" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "font-bold font-size-18" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "bg-color-grey-dc -mx-1 h-full-8px"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "bg-color-grey-dc -mx-1 h-full-8px"
}
const _hoisted_12 = {
  key: 0,
  class: "bg-color-grey-dc -mx-1 h-full-8px"
}
const _hoisted_13 = {
  key: 0,
  class: "bg-color-grey-dc -mx-1 h-full-8px"
}
const _hoisted_14 = {
  key: 0,
  class: "bg-color-grey-dc -mx-1 h-full-8px"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "mb-8" }
const _hoisted_17 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_19 = { class: "mb-8" }
const _hoisted_20 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  class: "flex"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-minus cursor-default font-size-32 text-red-ff border-1 border-color-grey-dc rounded-50 hover:opacity-75" }, null, -1)
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-2xl mr-2" }, null, -1)
const _hoisted_38 = { class: "mb-8" }
const _hoisted_39 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_41 = { class: "font-size-14 font-bold mb-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Table = _resolveComponent("Table")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_DatePickerInput = _resolveComponent("DatePickerInput")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")
  const _component_Button = _resolveComponent("Button")
  const _component_ReasonCreateApplication = _resolveComponent("ReasonCreateApplication")
  const _component_ReasonUpdateStatusApplication = _resolveComponent("ReasonUpdateStatusApplication")
  const _component_ApplicationApproveFlowDetail = _resolveComponent("ApplicationApproveFlowDetail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.goToBack }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('workRecordApplication')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.displayTargetDate(_ctx.targetDate)), 1),
      _createVNode(_component_Table, {
        class: "overflow-auto mt-1",
        headers: _ctx.checkTimeApplicationHeaders,
        data: _ctx.checkTimeApplication
      }, {
        type: _withId(({ index }) => [
          _createTextVNode(_toDisplayString(_ctx.checkTimeApplicationData[index].type), 1)
        ]),
        checkin_time: _withId(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(item.work_schedule_start_time), 1))
            : (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(item.checkin_time), 1))
        ]),
        checkout_time: _withId(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(item.work_schedule_end_time), 1))
            : (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(item.checkout_time), 1))
        ]),
        break_time: _withId(({ item, index }) => [
          _createVNode("pre", null, _toDisplayString(_ctx.displayScheduleBreakTime(item, index)), 1)
        ]),
        total_break_minutes: _withId(({ item }) => [
          _createVNode("div", null, _toDisplayString(_ctx.convertToDateTime(item.total_break_minutes, 'HH:mm')), 1)
        ]),
        go_out: _withId(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_9))
            : (item.go_out_start && item.go_out_end)
              ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(item.go_out_start) + " ~ " + _toDisplayString(item.go_out_end), 1))
              : _createCommentVNode("", true)
        ]),
        prescribed_outside_of_working_time: _withId(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_11))
            : _createCommentVNode("", true),
          _createVNode("div", null, _toDisplayString(_ctx.convertToDateTime(item.prescribed_outside_of_working_time)), 1)
        ]),
        statutory_outside_of_working_time: _withId(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_12))
            : _createCommentVNode("", true),
          _createVNode("div", null, _toDisplayString(_ctx.convertToDateTime(item.statutory_outside_of_working_time)), 1)
        ]),
        midnight_working_time: _withId(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_13))
            : _createCommentVNode("", true),
          _createVNode("div", null, _toDisplayString(_ctx.convertToDateTime(item.midnight_working_time)), 1)
        ]),
        is_remote: _withId(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_14))
            : (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(item.is_remote ? _ctx.t('telework') : _ctx.t('office')), 1))
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, _toDisplayString(_ctx.t('stampingRecord')), 1),
      _hoisted_18,
      _createVNode(_component_Table, {
        class: "w-120",
        headers: _ctx.stampRecordHeaders,
        data: _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time
      }, {
        check_time_type: _withId(({ item }) => [
          _createVNode("div", null, _toDisplayString(_ctx.getCheckTimeTypeName(item)), 1)
        ]),
        time: _withId(({ item }) => [
          _createVNode("div", null, _toDisplayString(_ctx.displayFormatTime(item.time, 'YYYY/MM/DD HH:mm:ss')), 1)
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ]),
    _createVNode("div", _hoisted_19, [
      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.t('fixedWorkResults')), 1),
      _hoisted_21,
      _createVNode("div", _hoisted_22, _toDisplayString(_ctx.t('fixedWorkResultsNote')), 1),
      _createVNode(_component_Table, {
        class: "w-180 mb-4",
        headers: _ctx.fixedWorkResultsHeaders,
        data: 
          _ctx.isDetail
            ? _ctx.checkTimeApplicationDetail.check_time_detail
            : _ctx.employeeCheckTimeAndWorkSchedule?.actual_check_time.concat(
                _ctx.formData.check_time_types
              )
        
      }, {
        check_time_type: _withId(({ item, index }) => [
          (_ctx.applicationFormId)
            ? (_openBlock(), _createBlock("div", _hoisted_23, _toDisplayString(_ctx.getCheckTimeTypeName(item)), 1))
            : (_openBlock(), _createBlock("div", _hoisted_24, [
                (
                index <
                _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
              )
                  ? (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(_ctx.getCheckTimeTypeName(item)), 1))
                  : (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 1,
                      placeholder: _ctx.t('placeholderSelect'),
                      "options-select": _ctx.checkTimeTypeList,
                      "item-value": "value",
                      "item-text": "label",
                      modelValue: 
                _ctx.formData.check_time_types[
                  index -
                    _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                ].type
              ,
                      "onUpdate:modelValue": ($event: any) => (
                _ctx.formData.check_time_types[
                  index -
                    _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                ].type
               = $event),
                      required: "",
                      validated: _ctx.validated,
                      errors: 
                _ctx.errors[
                  `check_time_types.${
                    index -
                    _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                  }.type`
                ]
              ,
                      "onUpdate:errors": ($event: any) => (
                _ctx.errors[
                  `check_time_types.${
                    index -
                    _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                  }.type`
                ]
               = $event),
                      "error-server": 
                _ctx.errorServer[
                  `check_time_types.${
                    index -
                    _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                  }.type`
                ]
              
                    }, null, 8, ["placeholder", "options-select", "modelValue", "onUpdate:modelValue", "validated", "errors", "onUpdate:errors", "error-server"]))
              ]))
        ]),
        time: _withId(({ item, index }) => [
          (_ctx.applicationFormId)
            ? (_openBlock(), _createBlock("div", _hoisted_26, _toDisplayString(_ctx.displayFormatTime(item.time, 'YYYY/MM/DD HH:mm:ss')), 1))
            : (_openBlock(), _createBlock("div", _hoisted_27, [
                (
                index <
                _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
              )
                  ? (_openBlock(), _createBlock("div", _hoisted_28, _toDisplayString(_ctx.displayFormatTime(item.time, 'YYYY/MM/DD HH:mm:ss')), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_29, [
                      _createVNode(_component_DatePickerInput, {
                        placeholder: 'YYYY/MM/DD',
                        class: "mr-1",
                        modelValue: 
                  _ctx.formData.check_time_types[
                    index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                  ].date
                ,
                        "onUpdate:modelValue": ($event: any) => (
                  _ctx.formData.check_time_types[
                    index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                  ].date
                 = $event),
                        required: "",
                        validated: _ctx.validated,
                        errors: 
                  _ctx.errors[
                    `check_time_types.${
                      index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                    }.date`
                  ]
                ,
                        "onUpdate:errors": ($event: any) => (
                  _ctx.errors[
                    `check_time_types.${
                      index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                    }.date`
                  ]
                 = $event),
                        "error-server": 
                  _ctx.errorServer[
                    `check_time_types.${
                      index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                    }.date`
                  ]
                
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "validated", "errors", "onUpdate:errors", "error-server"]),
                      _createVNode(_component_InputTime, {
                        modelValue: 
                  _ctx.formData.check_time_types[
                    index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                  ].time
                ,
                        "onUpdate:modelValue": ($event: any) => (
                  _ctx.formData.check_time_types[
                    index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                  ].time
                 = $event),
                        required: "",
                        validated: _ctx.validated,
                        errors: 
                  _ctx.errors[
                    `check_time_types.${
                      index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                    }.time`
                  ]
                ,
                        "onUpdate:errors": ($event: any) => (
                  _ctx.errors[
                    `check_time_types.${
                      index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                    }.time`
                  ]
                 = $event),
                        "error-server": 
                  _ctx.errorServer[
                    `check_time_types.${
                      index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                    }.time`
                  ]
                
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "validated", "errors", "onUpdate:errors", "error-server"])
                    ]))
              ]))
        ]),
        unit_name: _withId(({ item, index }) => [
          (_ctx.applicationFormId)
            ? (_openBlock(), _createBlock("div", _hoisted_30, _toDisplayString(item.unit_name), 1))
            : (_openBlock(), _createBlock("div", _hoisted_31, [
                (
                index <
                _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
              )
                  ? (_openBlock(), _createBlock("div", _hoisted_32, _toDisplayString(item.unit_name), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_33, [
                      _createVNode(_component_Dropdown, {
                        placeholder: _ctx.t('placeholderSelect'),
                        "options-select": _ctx.unitList,
                        "item-value": "unit_id",
                        "item-text": "unit_name",
                        modelValue: 
                  _ctx.formData.check_time_types[
                    index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                  ].unit_id
                ,
                        "onUpdate:modelValue": ($event: any) => (
                  _ctx.formData.check_time_types[
                    index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                  ].unit_id
                 = $event),
                        required: "",
                        validated: _ctx.validated,
                        errors: 
                  _ctx.errors[
                    `check_time_types.${
                      index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                    }.unit_id`
                  ]
                ,
                        "onUpdate:errors": ($event: any) => (
                  _ctx.errors[
                    `check_time_types.${
                      index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                    }.unit_id`
                  ]
                 = $event),
                        "error-server": 
                  _ctx.errorServer[
                    `check_time_types.${
                      index -
                      _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                    }.unit_id`
                  ]
                
                      }, null, 8, ["placeholder", "options-select", "modelValue", "onUpdate:modelValue", "validated", "errors", "onUpdate:errors", "error-server"])
                    ]))
              ]))
        ]),
        delete: _withId(({ item, index }) => [
          (
              index >
                _ctx.employeeCheckTimeAndWorkSchedule?.actual_check_time?.length -
                  1 && _ctx.isDetail
            )
            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                _hoisted_35
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_36, [
                (
                index <
                _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
              )
                  ? (_openBlock(), _createBlock(_component_CheckboxInput, {
                      key: 0,
                      disabled: _ctx.applicationFormId,
                      modelValue: item.is_delete,
                      "onUpdate:modelValue": ($event: any) => (item.is_delete = $event)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createBlock("span", {
                      key: 1,
                      onClick: ($event: any) => (
                _ctx.removeCheckTime(
                  index -
                    _ctx.employeeCheckTimeAndWorkSchedule.actual_check_time.length
                )
              ),
                      class: "cp-icon-minus cursor-pointer font-size-32 text-red-ff border-1 border-color-grey-dc rounded-50 hover:opacity-75"
                    }, null, 8, ["onClick"]))
              ]))
        ]),
        _: 1
      }, 8, ["headers", "data"]),
      _createVNode(_component_Button, {
        variant: "outline-primary",
        onClick: _ctx.addCheckTime,
        disabled: _ctx.applicationFormId
      }, {
        default: _withId(() => [
          _hoisted_37,
          _createTextVNode(_toDisplayString(_ctx.t('addAction')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _createVNode("div", _hoisted_38, [
      _createVNode("div", _hoisted_39, _toDisplayString(_ctx.t('breakTimeCorrection')), 1),
      _hoisted_40,
      _createVNode("div", _hoisted_41, _toDisplayString(_ctx.t('breakTimeTotal')), 1),
      (_ctx.isDetail)
        ? (_openBlock(), _createBlock(_component_InputTime, {
            key: 0,
            disabled: true,
            modelValue: _ctx.totalTime,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.totalTime = $event)),
            class: "w-32"
          }, null, 8, ["modelValue"]))
        : (_openBlock(), _createBlock(_component_InputTime, {
            key: 1,
            disabled: _ctx.applicationFormId,
            modelValue: _ctx.formData.total_break_time,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.total_break_time = $event)),
            class: "w-32",
            required: "",
            validated: _ctx.validated,
            errors: _ctx.errors.total_break_time,
            "onUpdate:errors": _cache[3] || (_cache[3] = ($event: any) => (_ctx.errors.total_break_time = $event)),
            "error-server": _ctx.errorServer.total_break_time
          }, null, 8, ["disabled", "modelValue", "validated", "errors", "error-server"]))
    ]),
    _createVNode(_component_ReasonCreateApplication, {
      "is-valid": !_ctx.isDisableSubmit,
      modelValue: _ctx.formData.application_reason,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.application_reason = $event)),
      validated: _ctx.validated,
      errors: _ctx.errors.application_reason,
      "onUpdate:errors": _cache[5] || (_cache[5] = ($event: any) => (_ctx.errors.application_reason = $event)),
      "error-server": _ctx.errorServer.application_reason,
      onHandleCreateApplication: _ctx.submitPostCheckTimeApplication,
      onHandleCancel: _ctx.backToTimeCard
    }, null, 8, ["is-valid", "modelValue", "validated", "errors", "error-server", "onHandleCreateApplication", "onHandleCancel"]),
    _createVNode(_component_ReasonUpdateStatusApplication, {
      status: _ctx.checkTimeApplicationDetail.application_status
    }, null, 8, ["status"]),
    _createVNode(_component_ApplicationApproveFlowDetail, {
      status: _ctx.checkTimeApplicationDetail.application_status,
      createdAt: _ctx.checkTimeApplicationDetail.created_at
    }, null, 8, ["status", "createdAt"])
  ]))
})